import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import {
  AdminRegistrationRequest,
  CustomerLoginRequest,
  CustomerLoginResponse,
  TenantRegisterRequest,
} from './auth.models';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(AppConfigService);

  private headers(): HttpHeaders {
    return new HttpHeaders({ 'X-App-Origin': this.appConfig.appId });
  }

  customerLogin(request: CustomerLoginRequest): Observable<CustomerLoginResponse> {
    return this.http.post<CustomerLoginResponse>(
      `${this.appConfig.apiUrl}/auth/customer-login`,
      request,
      { headers: this.headers() }
    );
  }

  forgotPassword(email: string): Observable<void> {
    return this.http.post<void>(
      `${this.appConfig.apiUrl}/auth/forgot-password`,
      { email, appId: this.appConfig.appId },
      { headers: this.headers() }
    );
  }

  registerTenant(request: Omit<TenantRegisterRequest, 'appId'>): Observable<unknown> {
    return this.http.post(
      `${this.appConfig.apiUrl}/auth/tenant/register`,
      { ...request, appId: this.appConfig.appId },
      { headers: this.headers() }
    );
  }

  requestAdminRegistration(request: AdminRegistrationRequest): Observable<unknown> {
    return this.http.post(
      `${this.appConfig.apiUrl}/auth/administration/registration-request`,
      request,
      { headers: this.headers() }
    );
  }
}
